'use client';

import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["isSelected", "multiselect", "selected", "allowClear", "onSelect", "value"];
import { CommandItem } from "../_shadcn-native-components/command";
import { useDropdownContext } from "./context";
import { jsx as _jsx } from "react/jsx-runtime";
export var DropdownBaseItem = function DropdownBaseItem(_ref) {
  var isSelected = _ref.isSelected,
    multiselect = _ref.multiselect,
    selected = _ref.selected,
    allowClear = _ref.allowClear,
    onSelect = _ref.onSelect,
    value = _ref.value,
    props = _objectWithoutProperties(_ref, _excluded);
  var _useDropdownContext = useDropdownContext(),
    values = _useDropdownContext.values,
    selectedItems = _useDropdownContext.selectedItems,
    setValues = _useDropdownContext.setValues,
    setOpen = _useDropdownContext.setOpen;
  var handleItemSelected = function handleItemSelected(newValue) {
    if (multiselect) {
      var newValues = values.includes(newValue) ? values.filter(function (item) {
        return item !== newValue;
      }) : [].concat(_toConsumableArray(values), [newValue]);
      if (onSelect) onSelect(newValues);
      if (!selected) setValues(newValues);
    } else {
      var isValueSelected = !!selectedItems.find(function (selected) {
        return selected.value === newValue;
      });
      var valueToPropagate = isValueSelected && allowClear ? null : newValue;
      if (onSelect && allowClear) onSelect(valueToPropagate);
      if (onSelect && !allowClear) onSelect(newValue);
      if (!selected) setValues(valueToPropagate ? [valueToPropagate] : []);
      setOpen(false);
    }
  };
  return /*#__PURE__*/_jsx(CommandItem, _objectSpread({
    value: value,
    onSelect: handleItemSelected,
    selected: isSelected
  }, props));
};